import React from 'react';
import { Grid, CircularProgress, Tooltip } from '@material-ui/core';
import { Info } from '@material-ui/icons';
import PropTypes from 'prop-types';
import DataTable from './auditTrailTable';
import { useQueryAutomationAuditInfo } from '../../../../hooks/useAuditTrail';
import { convertDateToPST } from '../../../../helpers/audit-trail';

const useStyles = () => ({
  loadingContent: {
    padding: '15px',
  },
});

const getColumns = () => [
  {
    field: 'change',
    headerClassName: 'audit-trail-groups',
    headerName: 'Change',
    width: 200,
    sortable: false,
    renderCell: params =>
      params.row.object_type && (
        <Tooltip arrow title={<h3>{params.row.object_type}</h3>}>
          <span className="table-cell-trucate">{params.row.object_type}</span>
        </Tooltip>
      ),
  },
  {
    field: 'old_value',
    headerClassName: 'audit-trail-groups',
    headerName: 'Old Value',
    width: 200,
    sortable: false,
    renderHeader: () => {
      return (
        <>
          <span>Old Value</span>
          <Tooltip
            arrow
            title={
              <h3>Shows the previous value, if text do not fit, please hover over the text, to see all the details</h3>
            }
          >
            <Info className="audit-trail-header-icons" />
          </Tooltip>
        </>
      );
    },
    renderCell: params => {
      let value = params.row.old_value;
      if (value && typeof value === 'object') {
        if (!Array.isArray(value)) {
          value = JSON.stringify(value);
        } else {
          value = value.join(',');
        }
      }
      return value ? (
        <Tooltip arrow title={<h3>{value}</h3>}>
          <span className="table-cell-trucate">{value}</span>
        </Tooltip>
      ) : null;
    },
  },
  {
    field: 'new_value',
    headerClassName: 'audit-trail-groups',
    cellClassName: 'audit-trail-groups-new-value',
    headerName: 'New Value',
    width: 200,
    sortable: false,
    renderHeader: () => {
      return (
        <>
          <span>New Value</span>
          <Tooltip
            arrow
            title={
              <h3>Shows the new value added, if text do not fit, please hover over the text, to see all the details</h3>
            }
          >
            <Info className="audit-trail-header-icons" />
          </Tooltip>
        </>
      );
    },
    renderCell: params => {
      let value = params.row.new_value;
      if (value && typeof value === 'object') {
        if (!Array.isArray(value)) {
          value = JSON.stringify(value);
        } else {
          value = value.join(',');
        }
      }
      return value ? (
        <Tooltip arrow title={<h3>{value}</h3>}>
          <span className="table-cell-trucate">{value}</span>
        </Tooltip>
      ) : null;
    },
  },
  {
    field: 'created_at',
    headerClassName: 'audit-trail-groups',
    headerName: 'Datetime',
    width: 150,
    renderHeader: () => {
      return (
        <>
          <span>Datetime</span>
          <Tooltip arrow title={<h3>Shows the datetime on when the change happenned (PST)</h3>}>
            <Info className="audit-trail-header-icons" />
          </Tooltip>
        </>
      );
    },
    renderCell: params =>
      params.row.created_at && (
        <Tooltip title={convertDateToPST(params.row.created_at)}>
          <span className="table-cell-trucate">{convertDateToPST(params.row.created_at)}</span>
        </Tooltip>
      ),
  },
  {
    field: 'created_by',
    headerClassName: 'audit-trail-groups',
    headerName: 'User/SystemID',
    width: 200,
    sortable: false,
    renderHeader: () => {
      return (
        <>
          <span>User / SystemID</span>
          <Tooltip arrow title={<h3>Shows who performed the changes, it could be a user email or an API</h3>}>
            <Info className="audit-trail-header-icons" />
          </Tooltip>
        </>
      );
    },
    renderCell: params =>
      params.row.created_by && (
        <Tooltip title={params.row.created_by}>
          <span className="table-cell-trucate">{params.row.created_by}</span>
        </Tooltip>
      ),
  },
];

const AutomationAuditContent = props => {
  const { event } = props;
  const classes = useStyles();
  const { data, isFetching } = useQueryAutomationAuditInfo(event);

  return isFetching ? (
    <div className={classes.loadingContent}>
      <Grid item xs={3}>
        <CircularProgress />
      </Grid>
    </div>
  ) : (
    <div
      style={{
        height: 550,
        width: '100%',
        padding: '15px',
        marginTop: '-15px',
      }}
    >
      <DataTable data={(data && data.response) || []} columns={getColumns()} />
    </div>
  );
};

AutomationAuditContent.propTypes = {
  event: PropTypes.object.isRequired,
};

export default AutomationAuditContent;
